import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { useState } from "react";
import { Dimmer } from "@/components/spinner";
import { Mensaje } from "@/components/mensajes2";
import { formatMoneda, validaMonto } from "@/util/varios";

export default function ModalClasificadorMulta(props) {
  const op = require("@/modulos/datos");
  const token = localStorage.getItem("jwtToken");
  const [titulo, setTitulo] = useState("Ver");
  const [loading, setLoading] = useState(false);
  const [body, setBody] = useState({
    codigo: "",
    tipo: "ACTIVIDADES ECONOMICAS",
    valor: "",
    descripcion: "",
  });
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const registrarClasificador = () => {
    setLoading(true);
    const endpoint = `${op.conexion}/api/gestion_comercial/registrar_clasificador`;
    axios
      .post(
        endpoint,
        {
          descripcion: body.descripcion,
          valor: body.valor,
          tipoImpuesto: body.tipo,
        },
        {
          headers: {
            "x-access-token": `${token}`,
            "Content-Type": "application/json",
          },
        },
      )
      .then((res) => {
        if (res.status === 200) {
          setMensaje({
            mostrar: true,
            texto: "Clasificador Creada Exitosamente",
            icono: "exito",
          });
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: "Error al Registrar el Clasificador",
          icono: "error",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const actualizarClasificador = () => {
    setLoading(true);
    const endpoint = `${op.conexion}/api/gestion_comercial/actualizar_clasificador`;
    axios
      .patch(
        endpoint,
        {
          id: body.codigo,
          descripcion: body.descripcion,
          valor: body.valor,
          tipoImpuesto: body.tipo,
        },
        {
          headers: {
            "x-access-token": `${token}`,
            "Content-Type": "application/json",
          },
        },
      )
      .then((res) => {
        if (res.status === 200) {
          setMensaje({
            mostrar: true,
            texto: "Clasificador Actualizado Exitosamente",
            icono: "exito",
          });
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: "Error al Actualizado el Clasificador",
          icono: "error",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const eliminarClasificador = () => {
    setLoading(true);
    const endpoint = `${op.conexion}/api/gestion_comercial/eliminar_clasificador?id=${body.codigo}`;
    axios
      .delete(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.status === 200) {
          setMensaje({
            mostrar: true,
            texto: "Clasificador Eliminado Exitosamente",
            icono: "exito",
          });
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: "Error al Eliminar el Clasificador",
          icono: "error",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const validarOperacion = () => {
    if (!body.descripcion) {
      setMensaje({
        mostrar: true,
        titulo: "",
        texto: "El Campo Descripcion no puede estar vacio",
        icono: "informacion",
      });
    } else if (!body.valor) {
      setMensaje({
        mostrar: true,
        titulo: "",
        texto: "El Campo Valor no puede estar vacio",
        icono: "informacion",
      });
    } else {
      switch (props.operacion) {
        case 1:
          registrarClasificador();
          break;
        case 3:
          actualizarClasificador();
          break;
        case 4:
          eliminarClasificador();
          break;
        default:
          break;
      }
    }
  };
  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (
      event.target.value === "" ||
      parseFloat(
        event.target.value.trim().replace(/\./g, "").replace(",", "."),
      ) === 0.0
    ) {
      event.target.value = "0,00";
    }
    if (event.which >= 37 && event.which <= 40) {
      event.preventDefault();
    }

    let e = event.target.value
      .replace(/\D/g, "")
      .replace(/([0-9])([0-9]{2})$/, "$1.$2")
      .replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ",");

    return formatMoneda(e);
  };
  const onChange = (e) => {
    const { value, name } = e.target;
    if (name === "valor") {
      const soloNumeros = value.replace(/[^0-9]/g, "");
      setBody((prev) => ({ ...prev, [name]: soloNumeros }));
    } else {
      setBody((prev) => ({ ...prev, [name]: value }));
    }
  };
  const blanquear = () => {
    setBody({
      codigo: "",
      tipo: "ACTIVIDADES ECONOMICAS",
      valor: "",
      descripcion: "",
    });
    setMensaje({
      mostrar: false,
      titulo: "",
      texto: "",
      icono: "",
    });
    setTitulo("Ver");
  };
  const salir = () => {
    blanquear();
    props.onHidden();
  };
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      onShow={() => {
        if (props.operacion > 1) {
          const { clasificador } = props;
          setBody({
            codigo: clasificador.idtipomulta,
            tipo: clasificador.tipoimpuesto.trim(),
            valor: clasificador.valor,
            descripcion: clasificador.descripcion.trim(),
          });
        }
        switch (props.operacion) {
          case 1:
            setTitulo("Incluir");
            break;
          case 3:
            setTitulo("Modificar");
            break;
          case 4:
            setTitulo("Eliminar");
            break;
          default:
            setTitulo("Ver");
            break;
        }
      }}
    >
      <Modal.Header className="azulGradiant px-4 py-2 text-uppercase">
        <h3 className="fs-4 fw-bold text-light m-0">{titulo} Clasificador</h3>
        <button className="btn btn-sm bg-light" onClick={() => salir()}>
          <i className="fa fa-times"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex justify-content-between">
          <div className="col-md-6 row py-2 m-0 p-0">
            <div className="input-group input-group-sm col-md-12 p-0 m-0">
              <span
                className="input-group-text text-uppercase"
                id="inputGroup-sizing-sm"
              >
                Tipo de Impuesto:
              </span>
              <select
                className="form-control text-uppercase"
                name="tipo"
                value={body.tipo}
                onChange={onChange}
                disabled={props.operacion === 2 || props.operacion === 4}
              >
                <option key="ACTIVIDADES ECONOMICAS">
                  ACTIVIDADES ECONOMICAS
                </option>
                <option key="RENTAS DE LICORES">RENTAS DE LICORES</option>
                <option key="INMUEBLES">INMUEBLES</option>
                <option key="VEHICULOS">VEHICULOS</option>
              </select>
            </div>
          </div>
          <div className="col-md-4 row my-auto py-2 m-0 p-0">
            <div className="input-group input-group-sm col-md-12 p-0 m-0">
              <span
                className="input-group-text text-uppercase"
                id="inputGroup-sizing-sm"
              >
                Valor de la Multa:
              </span>
              <input
                type="text"
                className="form-control text-uppercase text-end"
                aria-label="Sizing example input "
                aria-describedby="inputGroup-sizing-sm"
                name="valor"
                defaultValue={formatMoneda(
                  body.valor.toString().replace(".", ","),
                  ",",
                  ".",
                  2,
                )}
                onChange={onChange}
                onKeyUp={handleInputMontoChange}
                onBlur={handleInputMontoChange}
                disabled={props.operacion === 2 || props.operacion === 4}
              />
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-between"></div>
        <div className="d-flex justify-content-between">
          <div className="col-md-12 row my-auto py-2 m-0 p-0">
            <div className="input-group input-group-sm col-md-12 p-0 m-0">
              <span
                className="input-group-text text-uppercase"
                id="inputGroup-sizing-sm"
              >
                Descripcion
              </span>
              <textarea
                className="form-control text-uppercase"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
                name="descripcion"
                value={body.descripcion}
                onChange={onChange}
                style={{ height: 60 }}
                rows="3"
                disabled={props.operacion === 2 || props.operacion === 4}
              />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          onClick={() => validarOperacion()}
          className="btn-sm rounded-pill btn btn-primary col-md-2"
        >
          <i className="fa fa-check"></i> Aceptar
        </button>
        <button
          onClick={() => salir()}
          className="btn-sm rounded-pill btn btn-danger col-md-2"
        >
          <i className="fa fa-window-close"></i> Salir
        </button>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.icono === "exito"
            ? salir()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <Dimmer active={loading} inverted />
    </Modal>
  );
}
